import { OutstandingTableChangeStats } from "features/credit-facility/CreditFacilityPaydownPage";
import { useCreditFacilityPrincipalUsesRetrieveSuspense } from "gen/endpoints/credit-facility/credit-facility";
import { FundFamilyEventSubTypeEnum } from "gen/model/fundFamilyEventSubTypeEnum";
import { MoneyTableCellValue } from "gen/model/moneyTableCellValue";
import { useMemo } from "react";
import { TableBox } from "shared/components/table/box/TableBox";
import { TableBoxBody } from "shared/components/table/box/TableBoxBody";
import { TableBoxHeader } from "shared/components/table/box/TableBoxHeader";
import { TableBoxTitle } from "shared/components/table/box/TableBoxTitle";
import { DataTable } from "shared/components/table/data/DataTable";
import { DataTableBoxActions } from "shared/components/table/data/DataTableBoxActions";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { sumMoneyStrings } from "shared/utils/MoneyUtils";

interface CreditFacilityPrincipalUsesTableProps {
  fundFamilyEventId?: string;
  title?: string;
  eventType?: FundFamilyEventSubTypeEnum;
}

export const CreditFacilityPrincipalUsesTable: React.FC<
  CreditFacilityPrincipalUsesTableProps
> = ({
  fundFamilyEventId,
  title,
  eventType,
}: CreditFacilityPrincipalUsesTableProps) => {
  const { fundFamilyId, creditFacilityId } = useRequiredStringParams();

  const { data: tableData } = useCreditFacilityPrincipalUsesRetrieveSuspense(
    fundFamilyId,
    creditFacilityId,
    {
      ...(fundFamilyEventId && {
        fund_family_event_id: fundFamilyEventId,
      }),
    },
  );
  const changeAmount = useMemo(() => {
    if (!fundFamilyEventId) {
      return "";
    }
    return sumMoneyStrings(
      tableData.rows.map(
        (row) =>
          (row.cells.event_amounts_total.value as MoneyTableCellValue).amount,
      ),
    );
  }, [tableData.rows, fundFamilyEventId]);

  return (
    <TableBox isFullHeight={false} isFullWidth={true}>
      <TableBoxHeader>
        {title && <TableBoxTitle>{title}</TableBoxTitle>}
        <DataTableBoxActions showPivot={true} />
      </TableBoxHeader>
      {fundFamilyEventId && (
        <OutstandingTableChangeStats
          changeAmount={changeAmount}
          eventType={eventType!}
        />
      )}
      <TableBoxBody>
        <DataTable data={tableData} />
      </TableBoxBody>
    </TableBox>
  );
};
